import { useEffect, useState } from "react";

import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

type AlertProps = {
  message: string;
  type: 'info' | 'error' | 'success' | 'warning';
  autoHidden?: boolean;
  delay?: number; // ms
  className?: string;
  hideCloseButton?: boolean;
  link?: {label: string; target: string};
}

export default function Alert({
  message,
  type = "error",
  autoHidden = true,
  delay = 5000,
  className = '',
  hideCloseButton = false,
  link
}: AlertProps) {
  const [display, showMessage] = useState(true);
  const navigateTo = useNavigate();

  const styles = {
    error: "text-[#F43838] bg-[#FFE6E6] border border-[#F43838]",
    info: "text-[#0066B1] bg-[#E5F1FA] border border-[#0066B1]",
    success: "text-[#35D9A0] bg-[#D2FCE5] border border-[#35D9A0]",
    warning: "text-orange-600 bg-orange-200",
  }

  useEffect(() => {
    let timeout: number|null = null;
    if (autoHidden) {
      timeout = setTimeout(() => {
        showMessage(false);
      }, delay)
    }

    timeout && !display && clearTimeout(timeout);
    return () => {
      timeout && clearTimeout(timeout);
    }
  }, [autoHidden, delay, display])

  function hideAlert() {
    showMessage(false);
  }

  return (
    <>
      { display ? (
          <div className={`${styles[type]} ${className} ${link ? 'py-1.5' : 'py-3'} px-3 flex justify-between items-center gap-[18px] rounded-lg`}>
            <p className="text-sm">
              {message}
            </p>
            {
              link &&
              <span className={`${styles[type]} px-[13px] py-1.5 rounded-md cursor-pointer`}
                onClick={() => navigateTo(link.target)}>
                {link.label}
              </span>
            }
            { !hideCloseButton ? (
              <button className=""
              onClick={hideAlert}>
                <IoClose />
              </button> ) : <></>
            }
          </div>
        ) : <></>
      }
    </>
  )
}